<template>
  <div class="modal-dim on">
    <div class="modal-wrap">
      <div class="modal-inner bottom">
        <div class="modal consent-guide" :class="providerClass">
          <span class="consent-sheet-handle" aria-hidden="true"></span>
          <div class="modal-head">
            <div class="consent-eyebrow">
              <span class="consent-eyebrow-check" aria-hidden="true"></span>
              {{ providerLabel }} 로그인 꿀팁
            </div>
            <h1>이름·생년월일도 체크해 주세요</h1>
          </div>
          <div class="modal-con">
            <div class="modal-txt">
              <ul class="consent-benefit-list">
                <li class="consent-benefit-item">
                  <span class="consent-benefit-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="none" focusable="false">
                      <path d="M7 3.75h8.5L19 7.25v13H7v-16.5Z" />
                      <path d="M15.25 3.75v3.75H19M10 11h6M10 14.5h6M10 18h3.5" />
                    </svg>
                    <span class="consent-icon-check"></span>
                  </span>
                  <span class="consent-benefit-copy">
                    <strong>이름·생년월일이 자동으로 입력됩니다</strong>
                    <span>선택 항목인 이름·생년월일을 체크하시면 가입 화면에 자동으로 채워집니다.</span>
                  </span>
                </li>
                <li class="consent-benefit-item">
                  <span class="consent-benefit-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="none" focusable="false">
                      <rect x="7" y="3.5" width="10" height="17" rx="2.25" />
                      <path d="M10 6.5h4M11 17.5h2" />
                    </svg>
                    <span class="consent-icon-check"></span>
                  </span>
                  <span class="consent-benefit-copy">
                    <strong>전화번호 인증은 자동으로 끝납니다</strong>
                    <span>전화번호는 필수 항목으로 함께 제공되어 문자(SMS) 인증 없이 가입하실 수 있습니다.</span>
                  </span>
                </li>
                <li class="consent-benefit-item consent-benefit-item--safe">
                  <span class="consent-benefit-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="none" focusable="false">
                      <path d="M12 3.5 19 6.6v5.1c0 4.15-2.8 7.25-7 8.8-4.2-1.55-7-4.65-7-8.8V6.6l7-3.1Z" />
                    </svg>
                    <span class="consent-icon-check"></span>
                  </span>
                  <span class="consent-benefit-copy">
                    <strong>선택 동의에도 불이익은 전혀 없습니다</strong>
                    <span>가입에 필요한 정보 확인 용도로만 사용됩니다.</span>
                  </span>
                </li>
              </ul>
            </div>
          </div>
          <div class="modal-btn">
            <div class="btn-wrap">
              <button class="btn primary medium" @click="confirm">확인했습니다, {{ providerLabel }}로 계속</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { computed } from 'vue';
import { JOIN_TYPE } from '@/common/constants/ConstCode';

const props = defineProps(['data']);
const emits = defineEmits(['close']);

const providerLabel = computed(
  () => Object.values(JOIN_TYPE).find(t => t.value === props.data?.provider)?.label || '소셜'
);
const providerClass = computed(() => {
  if (props.data?.provider === JOIN_TYPE.KAKAO.value) return 'consent-guide--kakao';
  if (props.data?.provider === JOIN_TYPE.NAVER.value) return 'consent-guide--naver';
  return '';
});

// 카카오 팝업은 사용자 제스처 체인 안에서 열려야 팝업 차단에 안 걸린다 → setTimeout 없이 동기 호출.
const confirm = () => {
  emits('close');
  props.data?.onConfirm?.();
};
</script>

<style scoped>
.consent-guide {
  --consent-accent: #2f6df6;
  --consent-accent-soft: #e9f9e7;
  --consent-accent-ink: #ffffff;
  --consent-accent-text: #0f2480;
  color: #20242b;
  overflow: hidden;
  box-shadow: 0 -0.8rem 3.2rem rgba(15, 23, 42, 0.16);
}

.consent-guide,
.consent-guide * {
  box-sizing: border-box;
}

.consent-sheet-handle {
  display: block;
  flex: 0 0 auto;
  width: 4rem;
  height: 0.4rem;
  margin: 0.8rem auto 0;
  border-radius: 99rem;
  background: #d9dde4;
}

.consent-guide .modal-head {
  padding: 1.5rem 2rem 0;
  text-align: left;
}

.consent-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  min-height: 2.8rem;
  padding: 0.5rem 0.9rem 0.5rem 0.7rem;
  border-radius: 99rem;
  background: var(--consent-accent-soft);
  color: var(--consent-accent-text);
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1;
}

.consent-eyebrow-check {
  position: relative;
  flex: 0 0 auto;
  width: 1.7rem;
  height: 1.7rem;
  border-radius: 0.5rem;
  background: var(--consent-accent);
}

.consent-eyebrow-check::after,
.consent-icon-check::after {
  position: absolute;
  content: '';
  width: 0.7rem;
  height: 0.35rem;
  border-bottom: 0.2rem solid var(--consent-accent-ink);
  border-left: 0.2rem solid var(--consent-accent-ink);
  transform: rotate(-45deg);
}

.consent-eyebrow-check::after {
  top: 0.48rem;
  left: 0.45rem;
}

.consent-guide .modal-head h1 {
  margin: 1rem 0 0;
  color: #171a20;
  font-size: 2.2rem;
  font-weight: 700;
  line-height: 1.35;
  letter-spacing: -0.05rem;
  text-align: left;
  word-break: keep-all;
}

.consent-guide .modal-con {
  padding: 1.7rem 2rem 0;
  overflow-x: hidden;
  overscroll-behavior: contain;
}

.consent-guide .modal-txt {
  align-items: stretch;
  width: 100%;
  text-align: left;
}

.consent-benefit-list {
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
  width: 100%;
  min-width: 0;
  margin: 0;
  padding: 0;
  list-style: none;
}

.consent-benefit-item {
  display: grid;
  grid-template-columns: 4.2rem minmax(0, 1fr);
  align-items: center;
  gap: 1.2rem;
  width: 100%;
  min-width: 0;
  padding: 1.2rem 1.3rem;
  border: 0.1rem solid #edf0f3;
  border-radius: 1.4rem;
  background: #f8fafb;
}

.consent-benefit-icon {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 4.2rem;
  height: 4.2rem;
  border-radius: 1.3rem;
  background: var(--consent-accent-soft);
  color: var(--consent-accent-text);
}

.consent-benefit-icon svg {
  width: 2.3rem;
  height: 2.3rem;
  stroke: currentColor;
  stroke-width: 1.7;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.consent-icon-check {
  position: absolute;
  right: -0.25rem;
  bottom: -0.2rem;
  width: 1.7rem;
  height: 1.7rem;
  border: 0.2rem solid #ffffff;
  border-radius: 0.6rem;
  background: var(--consent-accent);
}

.consent-icon-check::after {
  top: 0.35rem;
  left: 0.3rem;
}

.consent-benefit-copy {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 0;
  word-break: keep-all;
}

.consent-benefit-copy strong {
  color: #292e36;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1.35;
  letter-spacing: -0.02rem;
}

.consent-benefit-copy > span {
  color: #68707d;
  font-size: 1.3rem;
  line-height: 1.45;
  letter-spacing: -0.01rem;
}

.consent-guide .modal-btn {
  flex: 0 0 auto;
}

.consent-guide .modal-btn .btn-wrap {
  padding: 1.8rem 2rem calc(1.6rem + env(safe-area-inset-bottom));
}

.consent-guide .modal-btn .btn {
  width: 100%;
  height: 5.2rem;
  margin: 0;
  border-radius: 1.4rem;
  box-shadow: 0 0.8rem 2rem rgba(47, 109, 246, 0.2);
  font-size: 1.6rem;
  font-weight: 700;
}

@media (max-width: 36rem) {
  .consent-guide .modal-head,
  .consent-guide .modal-con {
    padding-right: 1.6rem;
    padding-left: 1.6rem;
  }

  .consent-guide .modal-head h1 {
    font-size: 2rem;
  }

  .consent-guide .modal-btn .btn-wrap {
    padding-right: 1.6rem;
    padding-left: 1.6rem;
  }
}

/* 상태·provider 오버라이드는 기본 규칙 뒤에 둔다. */
.consent-benefit-item--safe {
  border-color: #e6e9ee;
  background: #f5f7f9;
}

.consent-benefit-item--safe .consent-benefit-icon {
  background: #e9edf2;
  color: #637083;
}

.consent-benefit-item--safe .consent-icon-check {
  --consent-accent-ink: #ffffff;
  background: #718096;
}

.consent-guide--kakao {
  --consent-accent: #fee500;
  --consent-accent-soft: #fff9d4;
  --consent-accent-ink: #191919;
  --consent-accent-text: #655b00;
}

.consent-guide--naver {
  --consent-accent: #03c75a;
  --consent-accent-soft: #e5f9ee;
  --consent-accent-ink: #ffffff;
  --consent-accent-text: #08357d;
}
</style>
